<template>
  <Dialog :open="open" @close="$emit('close')" width="720px">
    <template v-slot:title>
      <FlexRow full-width justify="center">
        <Label size="h6" bold text="リストを削除" />
      </FlexRow>
    </template>
    <template v-slot:default>
      <FlexRow justify="center">
        <FlexColumn width="640px">
          <Label text="リスト名" />
          <Label bold :text="listName" />
        </FlexColumn>
      </FlexRow>
    </template>
    <template v-slot:actions>
      <FlexRow full-width justify="center">
        <TextButton
            outlined
            @click="handleDelete"
        >
          削除する
        </TextButton>
        <TextButton
            primary
            @click="$emit('close')"
        >
          削除しない
        </TextButton>
      </FlexRow>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/components/atoms/Dialog";
import FlexRow from "@/components/atoms/FlexRow";
import TextButton from "@/components/atoms/TextButton";
import Label from "@/components/atoms/Label";
import ApiMixin from "@/ApiMixin";
import {mapGetters} from "vuex";
import FlexColumn from "@/components/atoms/FlexColumn";
export default {
  mixins: [ApiMixin],
  name: "ApplicantListDeleteDialog",
  components: {FlexColumn, Label, TextButton, FlexRow, Dialog},
  props: {
    open: {
      type: Boolean
    },
    list: {
      type: Object
    }
  },
  computed: {
    ...mapGetters("client", ["company"]),
    listName() {
      return this.list ? this.list.name : ""
    }
  },
  methods: {
    handleDelete() {
      this.deleteChatRequestList(this.company.id, this.list.id)
      this.$emit("close")
    }
  }
}
</script>

<style scoped>

</style>